import { 
  SET_HARVESTING_PROCEDURES, SET_LOADING
} from "../../types/contextTypes";

export default (state, action) => {
  switch(action.type){       
      case SET_LOADING:
        return {
          ...state,
            harvestingProceduresLoading: action.payload
        }     
      case SET_HARVESTING_PROCEDURES:
        return { 
          ...state, 
          allHarvestingProcedures: action.payload };

      default:
          return state;
  };
};